module.exports = __webpack_public_path__ + "static/item--blinds--f3@3x.859013c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--blinds--f3@3x.png
// module id = 630
// module chunks = 126511778744290